import { ensureError } from '@passionware/platform-js';
import { ensureLegacyApiError } from 'v5/platform/lang/ensureLegacyApiError';

const PLATFORM_ERROR_PREFIX = 'An error occurred: ';

export function getUserFacingErrorMessage(error: unknown): string {
  if (!(error instanceof Error)) {
    return ensureLegacyApiError(error).message;
  }

  if (error.message.startsWith(PLATFORM_ERROR_PREFIX)) {
    try {
      const parsed = JSON.parse(
        error.message.slice(PLATFORM_ERROR_PREFIX.length)
      );
      return ensureLegacyApiError(parsed).message;
    } catch {
      // Fall through to the raw message below.
    }
  }

  return ensureError(error).message;
}
